import './loading-spinner.css';
import Spinner from '../spinner/spinner';

export default function LoadingSpinner() {
  return (
    <div className="loading-spinner">
      <Spinner />
    </div>
  );
}
